import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Textarea } from 'primeng/textarea';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

interface TextAreaFieldProps extends FormlyFieldProps {
  rows?: number;
  cols?: number;
}

@Component({
  selector: 'textarea-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Textarea],
  template: `
    <textarea
      [rows]="props.rows"
      [cols]="props.cols"
      autocomplete="false"
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="w-full"
      pTextarea
    ></textarea>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextAreaFieldType extends FieldType<
  FieldTypeConfig<TextAreaFieldProps>
> {}
